
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/politique-des-cookies",
      function () {
        return require("private-next-pages/politique-des-cookies.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/politique-des-cookies"])
      });
    }
  